import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  RequestTypes,
  permitTemplatesKeys,
} from '@core/react-query/features/templates/permitTemplates'
import {
  IPermitTemplateRole,
  PermitTemplateRole,
} from '@core/entities/permit/PermitTemplateRoles'

const permitTemplateRolesTransform = (response: IPermitTemplateRole[]) =>
  response.map(PermitTemplateRole.new)

export const useGetPermitTemplateRoles = (
  payload: RequestTypes['getPermitTemplateRoles'],
  options?: UseQueryOptions<
    IPermitTemplateRole[],
    string,
    PermitTemplateRole[]
  >,
) => {
  return useQuery({
    select: permitTemplateRolesTransform,
    ...permitTemplatesKeys.getRoles(payload),
    ...options,
  })
}
